































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '../../../lib/util'
import AbpBase from '../../../lib/abpbase'
import ChannelList from '@/store/entities/channelmaintain'
import PageRequest from '@/store/entities/page-request'
import Enums from '@/lib/enums'

class SeachConfigTenantRequest extends PageRequest{
    Id: number
    TenancyName: string;
    
}
class CreateConfigTenantRequest {
    CongigurationId: number;
    TenantId: number;
}
@Component
export default class CreateConfigSetting extends AbpBase {
    @Prop({ type: Boolean, default: false }) value: boolean;
    tenant: SeachConfigTenantRequest = new SeachConfigTenantRequest();
    createtenant: CreateConfigTenantRequest = new CreateConfigTenantRequest();
    get list() {
        return this.$store.state.tenantsetting.list;
    };
    get loading() {
        return this.$store.state.tenantsetting.loading;
    }
    pageChange(page: number) {
        this.$store.commit('tenantsetting/setCurrentPage', page);
        this.getpage();
    }
    pagesizeChange(pagesize: number) {
        this.$store.commit('tenantsetting/setPageSize', pagesize);
        this.getpage();
    }
    async getpage() {
        this.tenant.Id = this.$store.state.tenantsetting.id;
        this.tenant.maxResultCount = this.pageSize;
        this.tenant.skipCount = (this.currentPage - 1) * this.pageSize;
        await this.$store.dispatch({
            type: 'tenantsetting/getAll',
            data: this.tenant
        })
    }
    get pageSize() {
        return this.$store.state.tenantsetting.pageSize;
    }
    get totalCount() {
        return this.$store.state.tenantsetting.totalCount;
    }
    get currentPage() {
        return this.$store.state.tenantsetting.currentPage;
    }
    async save() {
        var selectionData: any = this.$refs.selection;
        var selection = selectionData.getSelection();
        if (!selection || selection.length == 0) {
            this.$Message.error("选中项不能为空！");
            return;
        }
        var ids = [];
        for (var i = 0; i < selection.length; i++) {
            ids.push(selection[i].id);
        }
        this.createtenant.CongigurationId = this.$store.state.tenantsetting.id;
        await this.$store.dispatch({
            type: 'figtenant/create',
            data: { TenantId: ids, CongigurationId: this.createtenant.CongigurationId }
        });
        (this.$refs.tenantForm as any).resetFields();
        this.$emit('save-success');
        this.$emit('input', false);

    }
    columns = [
        {
            type: 'selection',
            width: 60,
            align: 'center',

        },
        {
            title: this.L('租户ID'),
            key: 'id',
        },
        {
            title: this.L('租户名称'),
            key: 'tenancyName',
        },
    ]
    cancel() {
        (this.$refs.tenantForm as any).resetFields();
        this.$emit('input', false);
    }
    visibleChange(value: boolean) {
        if (!value) {
            this.$emit('input', value);
        } else {
            this.getpage();
        }
    }
    async created() {
        //await this.getpage();
    }
}
